module.exports = __webpack_public_path__ + "img/signature.3c30e07a.png";